var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"margin-top":"320px","text-align":"center"}},[_vm._v(_vm._s(_vm.errMsg))])}
var staticRenderFns = []

export { render, staticRenderFns }